/* Used Brand — theme behaviour. No dependencies; runs identically in the
   local demo and on Shopify. */
(() => {
  'use strict';

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];

  /* ---------------------------------------------------------------- header */
  const header = $('[data-header]');
  if (header) {
    const sync = () => header.toggleAttribute('data-stuck', window.scrollY > 8);
    sync();
    window.addEventListener('scroll', sync, { passive: true });

    /* Line each mega menu up under the link that opens it. The panel is far
       wider than its trigger and is positioned against the header, so the
       offset has to be measured rather than written in CSS — and clamped, or
       a menu opened from the right-hand links would run off the screen. */
    const megaItems = $$('.header__item:has(.mega)', header);

    const placeMega = (item) => {
      const mega = $('.mega', item);
      const trigger = $('.header__link', item);
      if (!mega || !trigger) return;

      const gutter = 16;
      const headerBox = header.getBoundingClientRect();
      const triggerBox = trigger.getBoundingClientRect();
      const widest = headerBox.width - mega.offsetWidth - gutter;

      const x = Math.max(gutter, Math.min(triggerBox.left - headerBox.left, widest));
      mega.style.setProperty('--mega-x', `${Math.round(x)}px`);
      // Cancels the centring translate the stylesheet falls back to.
      mega.style.setProperty('--mega-shift', '0');
    };

    megaItems.forEach((item) => {
      // Measured on open rather than up front, because the row shifts as fonts
      // land and the panel has no width until it's been laid out.
      item.addEventListener('pointerenter', () => placeMega(item));
      item.addEventListener('focusin', () => placeMega(item));
    });

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => megaItems.forEach(placeMega), 150);
    });
  }

  /* --------------------------------------------------------------- drawers */
  let lastFocus = null;

  const openDrawer = (id) => {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.setAttribute('data-open', '');
    document.body.style.overflow = 'hidden';
    $('button, a, input', drawer)?.focus();
  };

  const closeDrawers = () => {
    $$('[data-drawer][data-open]').forEach((d) => d.removeAttribute('data-open'));
    document.body.style.overflow = '';
    lastFocus?.focus();
  };

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.dataset.drawerOpen);
      return;
    }
    if (e.target.closest('[data-drawer-close]')) {
      e.preventDefault();
      closeDrawers();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawers();
  });

  /* ----------------------------------------------------------------- rails */
  $$('[data-rail-nav]').forEach((nav) => {
    const rail = document.getElementById(nav.dataset.railNav);
    if (!rail) return;

    const prev = $('[data-rail-prev]', nav);
    const next = $('[data-rail-next]', nav);
    const step = () => rail.querySelector(':scope > *')?.getBoundingClientRect().width + 16 || 320;

    const sync = () => {
      const max = rail.scrollWidth - rail.clientWidth - 2;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max;
    };

    prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* --------------------------------------------------------- announcements */
  const bar = $('[data-announcement]');
  if (bar) {
    const items = $$('.announcement__item', bar);
    if (items.length > 1) {
      let i = 0;
      setInterval(() => {
        items[i].removeAttribute('data-active');
        i = (i + 1) % items.length;
        items[i].setAttribute('data-active', '');
      }, 5000);
    }
  }

  /* ------------------------------------------------------------ accordions */
  $$('[data-accordion]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const open = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!open));
      trigger.nextElementSibling.hidden = open;
    });
  });

  /* -------------------------------------------------------- product options */
  $$('.option__values').forEach((group) => {
    group.addEventListener('click', (e) => {
      const btn = e.target.closest('.option__value');
      if (!btn) return;
      $$('.option__value', group).forEach((b) => b.setAttribute('aria-pressed', 'false'));
      btn.setAttribute('aria-pressed', 'true');
    });
  });

  /* ------------------------------------------------------------ hero sound */
  $$('[data-hero-sound]').forEach((btn) => {
    const video = $('[data-hero-video]', btn.closest('.hero'));
    if (!video) return;
    btn.addEventListener('click', () => {
      video.muted = !video.muted;
      btn.setAttribute('aria-pressed', String(!video.muted));
    });
  });

  /* ------------------------------------------------------------ newsletter
     Posts in the background rather than letting the browser navigate, so the
     confirmation lands in place and anything listening (the goal tracker) can
     react. Without JS the form posts normally and Shopify handles it. */
  $$('.newsletter__form').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const button = $('button', form);
      const email = $('input[type="email"]', form)?.value.trim();
      if (button) button.disabled = true;

      try {
        await fetch(form.action, { method: 'POST', body: new FormData(form) });
      } catch {
        // Nothing useful to say if the network is down; fall through to the
        // confirmation rather than stranding the visitor mid-signup.
      }

      form.hidden = true;
      const note = form.parentElement.querySelector('[data-newsletter-success]');
      if (note) note.hidden = false;
      document.dispatchEvent(new CustomEvent('ub:signup', { detail: { email } }));
    });
  });

  /* ------------------------------------------------------ before / after */
  $$('[data-compare]').forEach((root) => {
    const inner = $('.ba__inner', root);
    if (!inner) return;

    const start = Number(root.dataset.start) || 55;
    let dragging = false;
    let touched = false;

    const setPos = (pct) => {
      const next = Math.max(0, Math.min(100, pct));
      root.style.setProperty('--ba-pos', `${next}%`);
      // The revealed side is a clipped window, so its track has to stay the
      // width of the whole frame or the photo inside squashes.
      inner.style.width = `${root.clientWidth}px`;
      root.setAttribute('aria-valuenow', Math.round(next));
    };

    const pctFrom = (e) => {
      const rect = root.getBoundingClientRect();
      const x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      return (x / rect.width) * 100;
    };

    const current = () => parseFloat(root.style.getPropertyValue('--ba-pos')) || start;

    const grab = (e) => {
      dragging = true;
      touched = true;
      setPos(pctFrom(e));
    };

    root.addEventListener('mousedown', (e) => { grab(e); e.preventDefault(); });
    window.addEventListener('mousemove', (e) => dragging && setPos(pctFrom(e)));
    window.addEventListener('mouseup', () => { dragging = false; });

    root.addEventListener('touchstart', grab, { passive: true });
    root.addEventListener('touchmove', (e) => dragging && setPos(pctFrom(e)), { passive: true });
    root.addEventListener('touchend', () => { dragging = false; });

    root.addEventListener('keydown', (e) => {
      const step = e.shiftKey ? 10 : 4;
      const moves = { ArrowLeft: -step, ArrowRight: step };
      if (e.key in moves) setPos(current() + moves[e.key]);
      else if (e.key === 'Home') setPos(0);
      else if (e.key === 'End') setPos(100);
      else return;
      touched = true;
      e.preventDefault();
    });

    window.addEventListener('resize', () => setPos(current()));
    setPos(start);

    // A short sweep on load so it reads as draggable without a tooltip. It
    // gives up for good the moment the visitor takes over.
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setTimeout(() => {
        const seq = [start - 5, start + 17, start - 23, start];
        let i = 0;
        const t = setInterval(() => {
          if (touched || i >= seq.length) return clearInterval(t);
          setPos(seq[i++]);
        }, 520);
      }, 700);
    }
  });

  /* ---------------------------------------------------------- goal tracker */
  $$('[data-tracker]').forEach((root) => {
    const countEl = $('[data-count]', root);
    const fillEl = $('[data-fill]', root);
    if (!countEl || !fillEl) return;

    const goal = Number(root.dataset.goal) || 1;
    let current = Number(root.dataset.current) || 0;
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

    const goalLabel = $('[data-goal-label]', root);
    if (goalLabel) goalLabel.textContent = goal.toLocaleString();

    const render = (target) => {
      setTimeout(() => {
        fillEl.style.width = `${Math.min(100, (target / goal) * 100)}%`;
      }, 300);

      if (reduce) {
        countEl.textContent = target.toLocaleString();
        return;
      }

      const duration = 1400;
      let t0 = null;
      const step = (ts) => {
        t0 ??= ts;
        const p = Math.min(1, (ts - t0) / duration);
        countEl.textContent = Math.round(target * (1 - (1 - p) ** 3)).toLocaleString();
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };

    // The count-up only pays off if it runs while it's on screen.
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            render(current);
            io.disconnect();
          });
        },
        { threshold: 0.4 }
      );
      io.observe(root);
    } else {
      render(current);
    }

    // Signing up moves the bar, which is the point of pairing the two.
    document.addEventListener('ub:signup', () => render(++current));
  });

  /* ------------------------------------------------------------ variant picker
     The option buttons are the visible control, but what gets posted is the
     `id` select. Clicking a button picks the matching variant and syncs the
     select, the price and the button state.

     The select also has to fire `change`. Apps like Vitals' sticky add-to-cart
     keep their own picker and only follow the theme when that event fires —
     setting `.value` alone leaves the footer on the first variant. */
  $$('.pdp__form').forEach((form) => {
    const select = $('[data-variant-select]', form);
    const data = $('[data-variant-data]', form);
    if (!select || !data) return;

    let variants = [];
    try {
      variants = JSON.parse(data.textContent);
    } catch {
      return; // Malformed data: leave the select as the working control.
    }

    const priceEl = $('[data-price]');
    const button = $('[data-add-to-cart]', form);
    const groups = $$('.option', form);
    const gallery = $('[data-gallery]');
    let syncing = false;

    const chosenOptions = () =>
      groups.map((group) => $('[aria-pressed="true"]', group)?.dataset.optionValue ?? null);

    const paint = (match) => {
      if (!match) return;

      select.value = String(match.id);

      groups.forEach((group, i) => {
        const wanted = match.options[i];
        $$('[data-option-value]', group).forEach((b) =>
          b.setAttribute('aria-pressed', String(b.dataset.optionValue === wanted))
        );
      });

      if (priceEl) {
        priceEl.innerHTML = match.on_sale
          ? `<del style="opacity:.5;margin-right:.5rem">${match.compare_at_price}</del>` +
            `<ins style="text-decoration:none;color:var(--ub-brick)">${match.price}</ins>`
          : match.price;
      }

      if (button) {
        button.disabled = !match.available;
        const label = $('span', button);
        if (label) label.textContent = match.available ? 'Add to bag' : 'Sold out';
      }

      // Show the picked colour. Moving the tile to the front rather than
      // hiding the others keeps every shot reachable, and makes it the lead
      // shot for free, since that treatment is bound to whatever sits first.
      // Variants don't always carry an image — the coolers have none — in
      // which case the gallery is left as it is.
      if (gallery && match.image_id) {
        const tile = $(`[data-media-id="${match.image_id}"]`, gallery);
        if (tile && tile !== gallery.firstElementChild) gallery.prepend(tile);
      }

      // Keep the URL shareable and the back button honest.
      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    };

    const matchFromButtons = () => {
      const wanted = chosenOptions();
      // Shopify orders variant.options to match options_with_values, so a
      // positional comparison is enough.
      return variants.find((v) =>
        wanted.every((value, i) => value === null || v.options[i] === value)
      );
    };

    const emitSelectChange = () => {
      if (syncing) return;
      syncing = true;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      syncing = false;
    };

    groups.forEach((group) => {
      group.addEventListener('click', (event) => {
        const value = event.target.closest('[data-option-value]');
        if (!value) return;
        $$('[data-option-value]', group).forEach((b) =>
          b.setAttribute('aria-pressed', String(b === value))
        );
        paint(matchFromButtons());
        emitSelectChange();
      });
    });

    select.addEventListener('change', () => {
      if (syncing) return;
      const match = variants.find((v) => String(v.id) === select.value);
      paint(match);
    });

    paint(matchFromButtons());

    /* Vitals mounts the sticky bar later and snapshots the first variant.
       When it appears (or becomes visible after scroll), push the current
       selection again so the footer doesn't stay on Gray / S. */
    const stickyId = 'bundle-sticky_add_to_cart';
    const bindSticky = (bar) => {
      const sync = () => {
        if (!bar.classList.contains('Vtl-StickyAddToCart--isVisible')) return;
        const shown = bar.querySelector('[data-selected-value]')?.getAttribute('data-selected-value');
        if (shown !== select.value) emitSelectChange();
      };
      new MutationObserver(sync).observe(bar, { attributes: true, attributeFilter: ['class'] });
      sync();
    };
    const existing = document.getElementById(stickyId);
    if (existing) bindSticky(existing);
    else {
      new MutationObserver((_, obs) => {
        const bar = document.getElementById(stickyId);
        if (!bar) return;
        obs.disconnect();
        bindSticky(bar);
      }).observe(document.body, { childList: true, subtree: true });
    }
  });

  /* --------------------------------------------------------------- add to cart
     Posts to Shopify's cart AJAX API, then re-renders the drawer from the
     server so it shows what the cart actually holds rather than a guess. */
  const cartCounts = () => $$('[data-cart-count]');

  const setCount = (n) => {
    cartCounts().forEach((el) => {
      el.textContent = String(n);
      el.toggleAttribute('hidden', n === 0);
    });
  };

  /* Repaints the drawer from the server, so it shows what the cart actually
     holds rather than a guess assembled in the browser.

     This uses the alternate cart template rather than the Section Rendering
     API: the drawer sits in the overlay section *group*, and Shopify returns
     null for a group-nested section, so ?sections=cart_drawer renders nothing. */
  const refreshDrawer = async () => {
    try {
      const response = await fetch('/cart?view=drawer', { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('drawer view unavailable');

      const fresh = new DOMParser().parseFromString(await response.text(), 'text/html');
      const body = $('[data-cart-items]', fresh);
      const foot = $('.drawer__foot', fresh);
      if (!body) throw new Error('drawer view empty');

      $('#cart-drawer [data-cart-items]')?.replaceWith(body);
      if (foot) $('#cart-drawer .drawer__foot')?.replaceWith(foot);
      return true;
    } catch {
      return false;
    }
  };

  const cartError = (form, message) => {
    const box = $('[data-cart-error]', form);
    if (!box) return;
    box.textContent = message;
    box.hidden = !message;
  };

  $$('.pdp__form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = $('[data-add-to-cart]', form);
      const label = $('span', button);
      const original = label?.textContent ?? 'Add to bag';

      cartError(form, '');
      button.disabled = true;
      if (label) label.textContent = 'Adding…';

      try {
        // Form-encoded rather than multipart: both are accepted, and this one
        // is smaller and parses with any standard body reader.
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams(new FormData(form)),
        });

        if (!response.ok) {
          // Shopify answers with a description for sold out, limits, etc.
          const problem = await response.json().catch(() => ({}));
          throw new Error(problem.description || 'Could not add that to your bag.');
        }

        const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        setCount(cart.item_count);
        await refreshDrawer();

        if (label) label.textContent = 'Added';
        setTimeout(() => {
          if (label) label.textContent = original;
          button.disabled = false;
          openDrawer('cart-drawer');
        }, 450);
      } catch (error) {
        cartError(form, error.message);
        if (label) label.textContent = original;
        button.disabled = false;
      }
    });
  });

  /* ------------------------------------------------------- cart line changes
     Quantity controls inside the drawer. Delegated, because the drawer markup
     is replaced wholesale after every change. */
  document.addEventListener('click', async (event) => {
    const control = event.target.closest('[data-line-change]');
    if (!control) return;
    event.preventDefault();

    const line = control.dataset.line;
    const quantity = control.dataset.lineChange;
    control.disabled = true;

    try {
      const cart = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
      }).then((r) => r.json());

      setCount(cart.item_count);
      if (!(await refreshDrawer())) window.location.reload();
    } catch {
      window.location.reload(); // Never leave the drawer showing a stale cart.
    }
  });

  /* Pause hero video when it scrolls out of view. */
  const videos = $$('[data-hero-video]');
  if (videos.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.play?.().catch(() => {});
          else entry.target.pause?.();
        });
      },
      { threshold: 0.1 }
    );
    videos.forEach((v) => io.observe(v));
  }
})();
